import React from "react";
import { getContentPageProps, getUniqueIdForContentTypeAlias } from "../../logic/contentLogic";

const HorizontalImageScroller = React.lazy(() => import("../../components/Magazine/modules/horizontalImageScrollerContainer/HorizontalImageScrollerContainer.js"));

export const renderHorizontalImageScroller = (content, props = {}) => {
  return <HorizontalImageScroller key={getUniqueIdForContentTypeAlias(content.contentTypeAlias)} content={content} {...getContentPageProps(content)} />;
};
